import { BREAKPOINT, ModalBasic } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const Modal = styled(ModalBasic)`
  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    height: calc(100vh - 160px);
    max-height: 42.5rem;
  }
`
